<template>
    <div class="header-lang header-right-item">
        <span @click="handleSetLanguage('zh')" class="header-lang-item" :class="{ active: language === 'zh' }">中文</span>
        <span style="margin: 0 15px">|</span>
        <span @click="handleSetLanguage('en')" class="header-lang-item" :class="{ active: language === 'en' }">English</span>
    </div>
</template>

<script>
export default {
    name: 'LangSelect',
    computed: {
        language() {
            document.title = this.$t('Form.Title')
            return this.$store.getters.language
        },
    },
    methods: {
        handleSetLanguage(lang) {
            this.$i18n.locale = lang
            this.$store.dispatch('app/setLanguage', lang)
            this.$message({
                message: lang === 'zh' ? '语言切换为中文' : 'Language is english',
                type: 'success',
            })
        },
    },
}
</script>

<style lang="scss" scoped>
$content-size: 32px;

.header-lang {
    line-height: $content-size;
    color: #b5b5b5;
    font-size: 18px;
    .header-lang-item {
        cursor: pointer;
        &.active {
            font-weight: bold;
            color: #fff;
        }
        &:hover {
            color: #fff;
        }
    }
} // header-lang
</style>
